import { InvoicePreviewRibbonVariant } from '@features/invoices/elements/InvoicePreviewRibbon'
import { InvoiceStatus } from '@features/invoices/enums/invoiceStatus'

interface InvoiceStatusInfo {
  tKey: string
  variant: InvoicePreviewRibbonVariant
}

export const invoiceStatusInfoMap: Partial<Record<InvoiceStatus, InvoiceStatusInfo>> = {
  [InvoiceStatus.Deleted]: {
    tKey: 'external_invoices.view.sidebar.details_card.status.voided',
    variant: 'grey',
  },
}
